module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjMDBBNEQ2IiBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPmFkZDwvdGl0bGU+PHBhdGggZD0iTTEyLDIyYS41LjUsMCwwLDEtLjUtLjVWMi41YS41LjUsMCwwLDEsMSwwdjE5QS41LjUsMCwwLDEsMTIsMjJaIi8+PHBhdGggZD0iTTIxLjUsMTIuNUgyLjVhLjUuNSwwLDAsMSwwLTFoMTlhLjUuNSwwLDAsMSwwLDFaIi8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./static/img/24px-add-blue.svg
// module id = 113
// module chunks = 1